import React from "react";
import calender from "../assets/images/MonthwiseComparison.png";
import Access from "../assets/images/Access.png";
import DataSecurity from "../assets/images/Data-Security.png";
import ExpenseSummery from "../assets/images/ExpenseSummery.png";
import Budget from "../assets/images/Budget.png";
import saving from "../assets/images/saving.png";

const features = [
  {
    imgSrc: calender,
    title: "Month Wise Comparison",
    description:
      "SmartSpend - Expense Manager lets you make monthly comparisons of spending, earnings,and expenses. ",
  },
  {
    imgSrc: Access,
    title: "Access From Anywhere",
    description:
      "Installing the Income Tracker App lets you access the cloud-based database anytime. ",
  },
  {
    imgSrc: DataSecurity,
    title: "Data Security",
    description:
      "It will be a suitable option for avoiding data loss of any kind. Receipt and bill data can be easily extracted, even behind the scenes. ",
  },
  {
    imgSrc: ExpenseSummery,
    title: "360-Degree Expense Summary",
    description:
      "Installing the Expense Tracker App helps get 360-degree expense summaries with intuitive graphs of spending.",
  },
  {
    imgSrc: Budget,
    title: "Build Daily and Monthly Budgets",
    description:
      "Making monthly financial planning easier by installing the SmartSpend - Expense Manager.",
  },
  {
    imgSrc: saving,
    title: "Money Saving Track Feature",
    description:
      "Grow your wealth by simply keeping monthly financial planning using the SmartSpend - Expense Manager. ",
  },
];

const Features = () => {
  return (
    <div className="px-8 lg:px-32 xl:px-52">
      <h2 className="text-center text-2xl lg:text-3xl font-bold mb-5 mt-14">
        App Features
      </h2>
      <div className="container mx-auto px-5 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:grid-cols-2">
          {features.map((feature, index) => (
            <div
              key={index}
              className=" shadow-lg rounded-lg p-6 border hover:shadow-[0_4px_10px_#1380E7]  transition-shadow duration-300"
            >
              <div className="flex justify-center mb-6">
                <img
                  src={feature.imgSrc}
                  alt={feature.title}
                  height={100}
                  className="max-h-[80px] features-img"
                />
              </div>
              <h3 className="text-[16px] font-semibold text-center mb-4 text-black">
                {feature.title}
              </h3>
              <p
                className="text-[#222222] text-center text-[14px] features-text"
                dangerouslySetInnerHTML={{ __html: feature.description }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
